(() => {
  const quickView = document.getElementById('Quick-view');
  if (!quickView) return;

  const dropdownSelector = 'float-element.variant-picker-dropdown[id*="---QuickView"]';
  const pendingDropdowns = new Map();

  const matchQuickViewScheme = (dropdown) => {
    const scheme = [...quickView.classList].find((name) => name.startsWith('color-'));
    if (!scheme) return;

    [...dropdown.classList].filter((name) => name.startsWith('color-')).forEach((name) => {
      dropdown.classList.remove(name);
    });
    dropdown.classList.add(scheme);
  };

  const removeDropdown = (dropdown) => {
    dropdown.removeUpdate?.();
    dropdown.remove();
    pendingDropdowns.delete(dropdown);
  };

  const removeDropdowns = () => {
    document.querySelectorAll(dropdownSelector).forEach(removeDropdown);
  };

  const removeOrphanedDropdowns = () => {
    if (!quickView.classList.contains('is-opened')) {
      removeDropdowns();
      return;
    }

    pendingDropdowns.forEach((opener, dropdown) => {
      if (!opener?.isConnected) removeDropdown(dropdown);
    });
  };

  quickView.addEventListener('click', (event) => {
    const opener = event.target.closest('dropdown-opener[data-float-element-id]');
    if (!opener) return;

    const dropdown = document.getElementById(opener.dataset.floatElementId);
    if (dropdown?.matches(dropdownSelector)) matchQuickViewScheme(dropdown);
  }, true);

  quickView.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const opener = event.target.closest('dropdown-opener[data-float-element-id]');
    if (!opener) return;

    const dropdown = document.getElementById(opener.dataset.floatElementId);
    if (dropdown?.matches(dropdownSelector)) matchQuickViewScheme(dropdown);
  }, true);

  document.addEventListener('change', (event) => {
    if (!event.target.matches('variant-picker[data-section*="---QuickView"] input[type="radio"]')) return;

    document.querySelectorAll(dropdownSelector).forEach((dropdown) => {
      if (dropdown.getAttribute('aria-hidden') !== 'false') return;

      const opener = quickView.querySelector(`[data-float-element-id="${dropdown.id}"]`);
      pendingDropdowns.set(dropdown, opener);
      dropdown.hide().then(removeOrphanedDropdowns);
    });
  }, true);

  new MutationObserver(removeOrphanedDropdowns).observe(quickView, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true,
  });
})();
